import { api } from "api";

export const getCompetency = (serviceType, tesvikStatus, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/competency/get/${serviceType}/${tesvikStatus}`)
      .then((res) => {
        dispatch({
          type: "GET_COMPETENCY_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_COMPETENCY_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
